import { useCallback, useEffect, useMemo, useState } from "react";

const AnaliseNaoConformidades = () => {
  const [dadosOriginais, setDadosOriginais] = useState([]);
  const [dadosManutencao, setDadosManutencao] = useState([]);
  const [loading, setLoading] = useState(true);
  const [abaAtiva, setAbaAtiva] = useState("detalhado");
  const [showModal, setShowModal] = useState(false);
  const [registroSelecionado, setRegistroSelecionado] = useState(null);
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [registrosPorPagina] = useState(20);
  const [formData, setFormData] = useState({
    centroCusto: "",
    natureza: "",
    classificacao: "",
    observacao: "",
  });

  // Configuração da API (ajustar conforme necessário)
  const API_BASE_URL = process.env.REACT_APP_API_URL;

  // ✅ FUNÇÃO PARA CARREGAR DADOS DE MANUTENÇÃO (AGRUPADOS)
  const CarregaDadosNaoConfAJustes = useCallback(async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("authToken");
      if (!token) {
        console.log("❌ Token não encontrado");
        setLoading(false);
        return;
      }

      const PCODCOLIGADA = localStorage.getItem("PCODCOLIGADA");
      const PCODFILIAL = localStorage.getItem("PCODFILIAL");
      const ANO = new Date().getFullYear();

      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      // ✅ CONSTRUÇÃO DA WHERE CLAUSE PARA BUSCAR DADOS AGRUPADOS
      let whereClause = `AND CODCOLIGADA = '${PCODCOLIGADA}' AND CODFILIAL = '${PCODFILIAL}' AND ANO = '${ANO}'`;

      console.log("🔍 Carregando dados de manutenção com WHERE:", whereClause);

      const response = await fetch(
        `${API_BASE_URL}/totvs-sql/sql_Man_ORC_0016/filter`,
        {
          method: "POST",
          headers,
          body: JSON.stringify({
            WHERE: whereClause,
            ORDER_BY: "CODCCUSTO, CODTBORCAMENTO",
          }),
        }
      );

      const result = await response.json();
      console.log("📋 Resultado dos dados de manutenção:", result);

      if (result.success && result.data) {
        // ✅ MAPEAR DADOS PARA O FORMATO DO FRONTEND
        const dadosMapeados = result.data.map((item) => ({
          ERRO: item.ERRO,
          CODCCUSTO: item.CODCCUSTO,
          CENTROCUSTO: item.CENTROCUSTO,
          CODTBORCAMENTO: item.CODTBORCAMENTO,
          NATUREZA: item.NATUREZA,
          QUANTIDADE: item.TOTAL || 1,
        }));

        console.log("✅ Dados de manutenção mapeados:", dadosMapeados);
        setDadosManutencao(dadosMapeados);
      } else {
        console.log("⚠️ Nenhum dado de manutenção encontrado");
        setDadosManutencao([]);
      }
    } catch (error) {
      console.error("❌ Erro ao carregar dados de manutenção:", error);
      setDadosManutencao([]);
    }
  }, [API_BASE_URL]);

  // ✅ FUNÇÃO PARA CARREGAR LISTAGEM DETALHADA
  const CarregaDadosListagemNaoConf = useCallback(async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("authToken");
      if (!token) {
        console.log("❌ Token não encontrado");
        setLoading(false);
        return;
      }

      const PCODCOLIGADA = localStorage.getItem("PCODCOLIGADA");
      const PCODFILIAL = localStorage.getItem("PCODFILIAL");
      const ANO = new Date().getFullYear();

      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      // ✅ CONSTRUÇÃO DA WHERE CLAUSE PARA BUSCAR LISTAGEM DETALHADA
      let whereClause = `AND CODCOLIGADA = '${PCODCOLIGADA}' AND CODFILIAL = '${PCODFILIAL}' AND ANO = '${ANO}'`;

      console.log("🔍 Carregando listagem detalhada com WHERE:", whereClause);

      const response = await fetch(
        `${API_BASE_URL}/totvs-sql/sql_Man_ORC_0017/filter`,
        {
          method: "POST",
          headers,
          body: JSON.stringify({
            WHERE: whereClause,
            ORDER_BY: "DTORIG DESC, CODCCUSTO, CODTBORCAMENTO",
          }),
        }
      );

      const result = await response.json();
      console.log("📋 Resultado da listagem detalhada:", result);

      if (result.success && result.data) {
        // ✅ MAPEAR DADOS PARA O FORMATO DO FRONTEND
        const dadosMapeados = result.data.map((item) => ({
          ERRO: item.ERRO,
          CODRESPLAN: item.CODRESPLAN,
          CODCCUSTO: item.CODCCUSTO,
          CENTROCUSTO: item.CENTROCUSTO,
          CODTBORCAMENTO: item.CODTBORCAMENTO,
          NATUREZA: item.NATUREZA,
          IDLAN: item.IDLAN,
          CODFILIAL: item.CODFILIAL,
          CODCOLIGADA: item.CODCOLIGADA,
          CODCFO: item.CODCFO,
          FORNECEDOR: item.FORNECEDOR,
          ORIGEM: item.ORIGEM,
          IDMOVORIG: item.IDMOVORIG,
          DTORIG: item.DTORIG,
          ANO: item.ANO,
          DESTINO: item.DESTINO,
          IDMOVDEST: item.IDMOVDEST,
          DTDEST: item.DTDEST,
          LIQUIDO: parseFloat(item.LIQUIDO) || 0,
          VALORRATC: parseFloat(item.VALORRATC) || 0,
          FLANSTATUS: item.FLANSTATUS,
          TIPO: item.TIPO,
          IDCONTRATO: item.IDCONTRATO,
          TMOVSTATUS: item.TMOVSTATUS,
          EMPENHADO: parseFloat(item.EMPENHADO) || 0,
        }));

        console.log("✅ Listagem detalhada mapeada:", dadosMapeados);
        setDadosOriginais(dadosMapeados);
      } else {
        console.log("⚠️ Nenhum dado detalhado encontrado");
        setDadosOriginais([]);
      }
    } catch (error) {
      console.error("❌ Erro ao carregar listagem detalhada:", error);
      setDadosOriginais([]);
    } finally {
      setLoading(false);
    }
  }, [API_BASE_URL]);

  // ✅ NOVA FUNÇÃO PARA INSERIR REGISTRO NA ZMDORC_ORCTO
  const inserirOrcamento = async (dadosNovoRegistro, tipoErro) => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        alert("❌ Token não encontrado");
        return { success: false, message: "Token não encontrado" };
      }

      const currentUsername =
        JSON.parse(atob(token.split(".")[1])).username ||
        JSON.parse(atob(token.split(".")[1])).id;

      const selectedYear = localStorage.getItem("selectedYear");
      const PCODCOLIGADA = localStorage.getItem("PCODCOLIGADA");
      const PCODFILIAL = localStorage.getItem("PCODFILIAL");

      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      // ✅ Monta o payload do insert
      const dadosParaInsert = {
        ano: parseInt(selectedYear, 10),
        codcoligada: parseInt(PCODCOLIGADA, 10),
        codfilial: parseInt(PCODFILIAL, 10),
        codccusto: String(dadosNovoRegistro.codccusto || ""),
        codtborcamento: String(dadosNovoRegistro.codtborcamento || ""),
        codtipo: String(dadosNovoRegistro.codtipo || ""),
        valor: parseFloat(dadosNovoRegistro.valor || 0),
        observacao: String(dadosNovoRegistro.observacao || ""),
        ativo:
          dadosNovoRegistro.ativo !== undefined ? dadosNovoRegistro.ativo : 1,
        usuario: String(currentUsername),
      };

      console.log("➕ Inserindo novo registro na ZMDORC_ORCTO...");
      console.log("📝 Dados para insert:", dadosParaInsert);

      const response = await fetch(
        `${API_BASE_URL}/SQlCustom/InsertNaoConformidade/`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(dadosParaInsert),
        }
      );

      const result = await response.json();

      // ✅ MENSAGENS PERSONALIZADAS BASEADAS NO TIPO DE ERRO
      const getMensagemPersonalizada = (tipoErro, sucesso) => {
        if (sucesso) {
          switch (tipoErro) {
            case "CC não existe para Natureza":
            case "Sem Orçamento":
              return "✅ Correção aplicada! Próximo passo: Solicitar para Solange dar manutenção para colocar gestor para esse centro de custo.";

            case "Natureza não existe para o CC":
              return "✅ Correção aplicada! A natureza já está disponível para consulta no sistema.";

            case "Sem Centro de Custo no Movimento":
            case "Sem Natureza Orçamentrária no Movimento":
              return "✅ Correção aplicada! Próximo passo: Verificar com time de compras porque não foi colocado o centro de custo ou natureza no movimento.";

            default:
              return "✅ Correção aplicada com sucesso!";
          }
        } else {
          switch (tipoErro) {
            case "CC não existe para Natureza":
            case "Sem Orçamento":
              return "❌ Erro ao aplicar correção. Verifique se os dados estão corretos e tente novamente. Lembre-se: será necessário solicitar para Solange dar manutenção para colocar gestor para esse centro de custo.";

            case "Natureza não existe para o CC":
              return "❌ Erro ao aplicar correção. Verifique se os dados estão corretos e tente novamente.";

            case "Sem Centro de Custo no Movimento":
            case "Sem Natureza Orçamentrária no Movimento":
              return "❌ Erro ao aplicar correção. Verifique se os dados estão corretos e tente novamente. Lembre-se: será necessário verificar com time de compras porque não foi colocado o centro de custo ou natureza no movimento.";

            default:
              return result.message || "Erro desconhecido ao aplicar correção.";
          }
        }
      };

      if (response.ok) {
        console.log("✅ Registro inserido com sucesso:", result);
        return {
          success: true,
          data: result,
          message: getMensagemPersonalizada(tipoErro, true),
        };
      } else {
        console.error("❌ Erro ao inserir registro:", result);
        return {
          success: false,
          message: getMensagemPersonalizada(tipoErro, false),
        };
      }
    } catch (error) {
      console.error("❌ Erro na requisição de inserção:", error);
      return {
        success: false,
        message:
          "❌ Erro de conexão. Verifique sua internet e tente novamente.",
      };
    }
  };

  // ✅ CARREGAR DADOS AO MONTAR O COMPONENTE
  useEffect(() => {
    const carregarTodosDados = async () => {
      setLoading(true);
      await Promise.all([
        CarregaDadosNaoConfAJustes(),
        CarregaDadosListagemNaoConf(),
      ]);
      setLoading(false);
    };

    carregarTodosDados();
  }, [CarregaDadosNaoConfAJustes, CarregaDadosListagemNaoConf]);

  // Calcular indicadores baseados na aba ativa
  const indicadores = useMemo(() => {
    if (abaAtiva === "detalhado") {
      const totalRegistros = dadosOriginais.length;
      const valorTotal = dadosOriginais.reduce((sum, item) => {
        const valor = parseFloat(item.LIQUIDO) || 0;
        return sum + valor;
      }, 0);

      const dadosCompras = dadosOriginais.filter(
        (item) => item.ORIGEM === "1.1.37"
      );
      const dadosFinanceiro = dadosOriginais.filter(
        (item) => item.ORIGEM === "FIN"
      );
      const dadosExtratoCaixa = dadosOriginais.filter(
        (item) => item.ORIGEM === "FXCX"
      );

      return {
        totalRegistros,
        valorTotal,
        compras: {
          quantidade: dadosCompras.length,
          valor: dadosCompras.reduce(
            (sum, item) => sum + (parseFloat(item.LIQUIDO) || 0),
            0
          ),
        },
        financeiro: {
          quantidade: dadosFinanceiro.length,
          valor: dadosFinanceiro.reduce(
            (sum, item) => sum + (parseFloat(item.LIQUIDO) || 0),
            0
          ),
        },
        extratoCaixa: {
          quantidade: dadosExtratoCaixa.length,
          valor: dadosExtratoCaixa.reduce(
            (sum, item) => sum + (parseFloat(item.LIQUIDO) || 0),
            0
          ),
        },
      };
    } else {
      const totalRegistros = dadosManutencao.reduce(
        (sum, item) => sum + (item.QUANTIDADE || 0),
        0
      );

      const tiposErro = dadosManutencao.reduce((acc, item) => {
        acc[item.ERRO] = (acc[item.ERRO] || 0) + (item.QUANTIDADE || 0);
        return acc;
      }, {});

      const centrosCusto = dadosManutencao.reduce((acc, item) => {
        if (!acc[item.CODCCUSTO]) {
          acc[item.CODCCUSTO] = { descricao: item.CENTROCUSTO, quantidade: 0 };
        }
        acc[item.CODCCUSTO].quantidade += item.QUANTIDADE || 0;
        return acc;
      }, {});

      return {
        totalRegistros,
        tiposErro,
        centrosCustoCount: Object.keys(centrosCusto).length,
        naturezasCount: dadosManutencao.length,
        topCentrosCusto: Object.entries(centrosCusto)
          .sort(([, a], [, b]) => b.quantidade - a.quantidade)
          .slice(0, 5),
      };
    }
  }, [dadosOriginais, dadosManutencao, abaAtiva]);

  // Paginação
  const dadosParaPaginacao =
    abaAtiva === "detalhado" ? dadosOriginais : dadosManutencao;
  const dadosPaginados = useMemo(() => {
    const inicio = (paginaAtual - 1) * registrosPorPagina;
    const fim = inicio + registrosPorPagina;
    return dadosParaPaginacao.slice(inicio, fim);
  }, [dadosParaPaginacao, paginaAtual, registrosPorPagina]);

  const totalPaginas = Math.ceil(
    dadosParaPaginacao.length / registrosPorPagina
  );

  // Resetar paginação ao trocar de aba
  useEffect(() => {
    setPaginaAtual(1);
  }, [abaAtiva]);

  // Funções do modal
  const abrirModal = (registro) => {
    setRegistroSelecionado(registro);
    if (abaAtiva === "detalhado") {
      setFormData({
        centroCusto: registro.CODCCUSTO || "",
        natureza: registro.CODTBORCAMENTO || "",
        classificacao: "",
        observacao: "",
      });
    } else {
      setFormData({
        centroCusto: registro.CODCCUSTO || "",
        natureza: registro.CODTBORCAMENTO || "",
        classificacao: "",
        observacao: `Correção em lote para ${registro.QUANTIDADE} registros`,
      });
    }
    setShowModal(true);
  };

  const fecharModal = () => {
    setShowModal(false);
    setRegistroSelecionado(null);
    setFormData({
      centroCusto: "",
      natureza: "",
      classificacao: "",
      observacao: "",
    });
  };

  // ✅ FUNÇÃO ATUALIZADA PARA SALVAR AJUSTE
  const salvarAjuste = async () => {
    try {
      console.log("Salvando ajustes:", {
        registro: registroSelecionado,
        ajustes: formData,
        aba: abaAtiva,
      });

      // Validação básica
      if (!formData.classificacao) {
        alert("Por favor, selecione uma classificação antes de salvar.");
        return;
      }

      if (abaAtiva === "manutencao") {
        // ✅ PREPARAR DADOS PARA INSERÇÃO NA TABELA DE ORÇAMENTO
        const dadosParaInsercao = {
          codccusto: registroSelecionado.CODCCUSTO,
          codtborcamento: registroSelecionado.CODTBORCAMENTO || "",
          codtipo: formData.classificacao,
          valor: 0, // Valor inicial zerado, pode ser ajustado posteriormente
          observacao: formData.observacao,
          ativo: 1,
        };

        console.log("📝 Dados preparados para inserção:", dadosParaInsercao);

        // ✅ CHAMAR FUNÇÃO DE INSERÇÃO COM TIPO DE ERRO
        const tipoErro = registroSelecionado.ERRO;
        const resultado = await inserirOrcamento(dadosParaInsercao, tipoErro);

        if (resultado.success) {
          // ✅ USAR MENSAGEM PERSONALIZADA
          alert(
            `${resultado.message}\n\nQuantidade de registros afetados: ${registroSelecionado.QUANTIDADE}`
          );

          // Fechar modal
          fecharModal();

          // Recarregar dados após salvar
          await Promise.all([
            CarregaDadosNaoConfAJustes(),
            CarregaDadosListagemNaoConf(),
          ]);
        } else {
          // ✅ USAR MENSAGEM DE ERRO PERSONALIZADA
          alert(resultado.message);
        }
      } else {
        // Para aba detalhado, manter lógica original (se necessário)
        alert("Ajuste salvo com sucesso!");
        fecharModal();
        await CarregaDadosListagemNaoConf();
      }
    } catch (error) {
      console.error("❌ Erro ao salvar ajuste:", error);
      alert(
        "❌ Erro inesperado ao salvar ajuste. Verifique sua conexão e tente novamente."
      );
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Navegação da paginação
  const irParaPagina = (pagina) => {
    setPaginaAtual(pagina);
  };

  const paginaAnterior = () => {
    if (paginaAtual > 1) {
      setPaginaAtual(paginaAtual - 1);
    }
  };

  const proximaPagina = () => {
    if (paginaAtual < totalPaginas) {
      setPaginaAtual(paginaAtual + 1);
    }
  };

  if (loading) {
    return (
      // Mesmo invólucro da tela pronta, para não haver troca de fundo e
      // largura quando o carregamento termina.
      <div className="container-fluid py-2 px-4" style={{ minHeight: "100vh" }}>
        <div
          className="bg-white rounded shadow p-4 d-flex justify-content-center align-items-center"
          style={{ backgroundColor: "#ffffffb3", height: "400px" }}
        >
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Carregando...</span>
          </div>
          <div className="ms-3">
            <h5 className="text-primary">
              Carregando dados de não conformidades...
            </h5>
            <p className="text-muted">
              Aguarde enquanto buscamos as informações mais atuais
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    // Mesmo invólucro das telas de lançamento (ver Lacamentos.jsx): largura
    // cheia com px-4 e cartão branco translúcido, no lugar do fundo cinza.
    <div className="container-fluid py-2 px-4" style={{ minHeight: "100vh" }}>
      <div
        className="bg-white rounded shadow p-4"
        style={{ backgroundColor: "#ffffffb3" }}
      >
        {/* TÍTULO — 1,50rem como nas demais telas; era 2,50rem. */}
        <h5
          className="text-dark fw-semibold mb-1"
          style={{ fontSize: "1.50rem" }}
        >
          <i className="bi bi-exclamation-triangle-fill me-2 text-danger"></i>
          Não Conformidades{" "}
          <b className="text-danger">Orçamentárias</b> —{" "}
          <span className="text-dark fw-semibold">
            ✅ Ano {localStorage.getItem("selectedYear")} -{" "}
            {localStorage.getItem("NomeFilial")}
          </span>
        </h5>

        <p className="text-muted small mb-4">
          Controle e monitoramento de inconsistências orçamentárias
        </p>

      {/* Abas */}
      <div className="row mb-4">
        <div className="col-12">
          <ul className="nav nav-tabs nav-tabs-lg">
            <li className="nav-item">
              <button
                className={`nav-link ${
                  abaAtiva === "detalhado" ? "active" : ""
                }`}
                onClick={() => setAbaAtiva("detalhado")}
              >
                <i className="bi bi-list-ul me-2"></i>
                Detalhado
                <span className="badge bg-primary ms-2">
                  {dadosOriginais.length}
                </span>
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${
                  abaAtiva === "manutencao" ? "active" : ""
                }`}
                onClick={() => setAbaAtiva("manutencao")}
              >
                <i className="bi bi-tools me-2"></i>
                Manutenção
                <span className="badge bg-warning text-dark ms-2">
                  {dadosManutencao.length}
                </span>
              </button>
            </li>
          </ul>
        </div>
      </div>

      {/* Indicadores */}
      {abaAtiva === "detalhado" ? (
        <div className="row mb-4">
          <div className="col-lg-2 col-md-6 mb-3">
            <div className="card bg-primary text-white shadow-sm h-100">
              <div className="card-body text-center">
                <h6 className="card-title text-uppercase fw-bold opacity-75 mb-2">
                  Total Geral
                </h6>
                <h4 className="mb-1 fw-bold">{indicadores.totalRegistros}</h4>
                <small className="opacity-75">registros</small>
                <hr className="my-2 opacity-50" />
                <h5 className="mb-0 fw-bold">
                  {indicadores.valorTotal?.toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}
                </h5>
              </div>
            </div>
          </div>

          <div className="col-lg-2 col-md-6 mb-3">
            <div className="card bg-success text-white shadow-sm h-100">
              <div className="card-body text-center">
                <h6 className="card-title text-uppercase fw-bold opacity-75 mb-2">
                  <i className="bi bi-cart-fill me-1"></i>
                  Compras
                </h6>
                <h4 className="mb-1 fw-bold">
                  {indicadores.compras?.quantidade}
                </h4>
                <small className="opacity-75">registros</small>
                <hr className="my-2 opacity-50" />
                <h6 className="mb-0 fw-bold">
                  {indicadores.compras?.valor.toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}
                </h6>
              </div>
            </div>
          </div>

          <div className="col-lg-2 col-md-6 mb-3">
            <div className="card bg-warning text-dark shadow-sm h-100">
              <div className="card-body text-center">
                <h6 className="card-title text-uppercase fw-bold opacity-75 mb-2">
                  <i className="bi bi-bank me-1"></i>
                  Financeiro
                </h6>
                <h4 className="mb-1 fw-bold">
                  {indicadores.financeiro?.quantidade}
                </h4>
                <small className="opacity-75">registros</small>
                <hr className="my-2 opacity-50" />
                <h6 className="mb-0 fw-bold">
                  {indicadores.financeiro?.valor.toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}
                </h6>
              </div>
            </div>
          </div>

          <div className="col-lg-2 col-md-6 mb-3">
            <div className="card bg-info text-white shadow-sm h-100">
              <div className="card-body text-center">
                <h6 className="card-title text-uppercase fw-bold opacity-75 mb-2">
                  <i className="bi bi-cash-stack me-1"></i>
                  Extrato Caixa
                </h6>
                <h4 className="mb-1 fw-bold">
                  {indicadores.extratoCaixa?.quantidade}
                </h4>
                <small className="opacity-75">registros</small>
                <hr className="my-2 opacity-50" />
                <h6 className="mb-0 fw-bold">
                  {indicadores.extratoCaixa?.valor.toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}
                </h6>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-12 mb-3">
            <div className="card bg-dark text-white shadow-sm h-100">
              <div className="card-body">
                <h6 className="card-title text-uppercase fw-bold opacity-75 mb-3">
                  <i className="bi bi-pie-chart-fill me-2"></i>
                  Distribuição Percentual
                </h6>
                <div className="row text-center">
                  <div className="col-4">
                    <div className="border-end border-secondary">
                      <h5 className="text-success mb-1">
                        {indicadores.totalRegistros > 0
                          ? (
                              (indicadores.compras?.quantidade /
                                indicadores.totalRegistros) *
                              100
                            ).toFixed(1)
                          : 0}
                        %
                      </h5>
                      <small className="opacity-75">Compras</small>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="border-end border-secondary">
                      <h5 className="text-warning mb-1">
                        {indicadores.totalRegistros > 0
                          ? (
                              (indicadores.financeiro?.quantidade /
                                indicadores.totalRegistros) *
                              100
                            ).toFixed(1)
                          : 0}
                        %
                      </h5>
                      <small className="opacity-75">Financeiro</small>
                    </div>
                  </div>
                  <div className="col-4">
                    <h5 className="text-info mb-1">
                      {indicadores.totalRegistros > 0
                        ? (
                            (indicadores.extratoCaixa?.quantidade /
                              indicadores.totalRegistros) *
                            100
                          ).toFixed(1)
                        : 0}
                      %
                    </h5>
                    <small className="opacity-75">Extrato</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="row mb-4">
          <div className="col-lg-3 col-md-6 mb-3">
            <div className="card bg-danger text-white shadow-sm h-100">
              <div className="card-body text-center">
                <h6 className="card-title text-uppercase fw-bold opacity-75 mb-2">
                  <i className="bi bi-exclamation-triangle me-1"></i>
                  Total Problemas
                </h6>
                <h2 className="mb-0 fw-bold">{indicadores.totalRegistros}</h2>
                <small className="opacity-75">ocorrências</small>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-6 mb-3">
            <div className="card bg-warning text-dark shadow-sm h-100">
              <div className="card-body text-center">
                <h6 className="card-title text-uppercase fw-bold opacity-75 mb-2">
                  <i className="bi bi-diagram-3 me-1"></i>
                  Centros de Custo
                </h6>
                <h2 className="mb-0 fw-bold">
                  {indicadores.centrosCustoCount}
                </h2>
                <small className="opacity-75">afetados</small>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-6 mb-3">
            <div className="card bg-info text-white shadow-sm h-100">
              <div className="card-body text-center">
                <h6 className="card-title text-uppercase fw-bold opacity-75 mb-2">
                  <i className="bi bi-list-check me-1"></i>
                  Tipos de Erro
                </h6>
                <h2 className="mb-0 fw-bold">
                  {Object.keys(indicadores.tiposErro || {}).length}
                </h2>
                <small className="opacity-75">diferentes</small>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-6 mb-3">
            <div className="card bg-success text-white shadow-sm h-100">
              <div className="card-body text-center">
                <h6 className="card-title text-uppercase fw-bold opacity-75 mb-2">
                  <i className="bi bi-code-square me-1"></i>
                  Combinações
                </h6>
                <h2 className="mb-0 fw-bold">{indicadores.naturezasCount}</h2>
                <small className="opacity-75">CC + Natureza</small>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Tabela */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="card shadow-sm">
            <div className="card-header bg-dark text-white d-flex justify-content-between align-items-center">
              <h5 className="mb-0">
                <i className="bi bi-table me-2"></i>
                {abaAtiva === "detalhado"
                  ? "Lista de Não Conformidades"
                  : "Agrupamento para Manutenção"}
              </h5>
              <div>
                <span className="badge bg-light text-dark me-2">
                  Página {paginaAtual} de {totalPaginas}
                </span>
                <span className="badge bg-secondary">
                  {dadosParaPaginacao.length} registros
                </span>
              </div>
            </div>
            <div className="card-body p-0">
              <div className="table-responsive">
                {abaAtiva === "detalhado" ? (
                  <table className="table table-hover table-striped mb-0">
                    <thead className="table-dark">
                      <tr>
                        <th>Tipo de Erro</th>
                        <th>Origem</th>
                        <th>Responsável</th>
                        <th>Fornecedor</th>
                        <th>Centro de Custo</th>
                        <th>Natureza</th>
                        <th>Valor Líquido</th>
                        <th>Data</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dadosPaginados.map((item, index) => (
                        <tr key={index}>
                          <td>
                            <span className="badge bg-danger">
                              {item.ERRO === "Natureza não existe para o CC"
                                ? "Natureza não existe"
                                : item.ERRO ===
                                  "Sem Natureza Orçamentrária no Movimento"
                                ? "Sem Natureza"
                                : item.ERRO}
                            </span>
                          </td>
                          <td>
                            <span
                              className={`badge ${
                                item.ORIGEM === "1.1.37"
                                  ? "bg-success"
                                  : item.ORIGEM === "FIN"
                                  ? "bg-warning text-dark"
                                  : item.ORIGEM === "FXCX"
                                  ? "bg-info"
                                  : "bg-secondary"
                              }`}
                            >
                              {item.ORIGEM === "1.1.37"
                                ? "Compras"
                                : item.ORIGEM === "FIN"
                                ? "Financeiro"
                                : item.ORIGEM === "FXCX"
                                ? "Extrato Caixa"
                                : item.ORIGEM}
                            </span>
                          </td>
                          <td>
                            <small className="fw-semibold">
                              {item.CODRESPLAN}
                            </small>
                          </td>
                          <td
                            className="text-truncate"
                            style={{ maxWidth: "150px" }}
                            title={item.FORNECEDOR}
                          >
                            <small>{item.FORNECEDOR || "N/A"}</small>
                          </td>
                          <td>
                            <div>
                              <strong className="font-monospace">
                                {item.CODCCUSTO}
                              </strong>
                              <br />
                              <small className="text-muted">
                                {item.CENTROCUSTO}
                              </small>
                            </div>
                          </td>
                          <td>
                            <div>
                              <strong className="font-monospace">
                                {item.CODTBORCAMENTO || "NULL"}
                              </strong>
                              <br />
                              <small className="text-muted">
                                {item.NATUREZA || "N/A"}
                              </small>
                            </div>
                          </td>
                          <td className="fw-bold text-end">
                            {parseFloat(item.LIQUIDO || 0).toLocaleString(
                              "pt-BR",
                              {
                                style: "currency",
                                currency: "BRL",
                              }
                            )}
                          </td>
                          <td>
                            <small>
                              {item.DTORIG
                                ? new Date(item.DTORIG).toLocaleDateString(
                                    "pt-BR"
                                  )
                                : "N/A"}
                            </small>
                          </td>
                          <td>
                            <span
                              className={`badge ${
                                item.FLANSTATUS === "Baixado"
                                  ? "bg-success"
                                  : item.FLANSTATUS === "Em Aberto"
                                  ? "bg-warning text-dark"
                                  : "bg-secondary"
                              }`}
                            >
                              {item.FLANSTATUS || "N/A"}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <table className="table table-hover table-striped mb-0">
                    <thead className="table-dark">
                      <tr>
                        <th>Tipo de Erro</th>
                        <th>Centro de Custo</th>
                        <th>Natureza</th>
                        <th>Quantidade</th>
                        <th>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dadosPaginados.map((item, index) => (
                        <tr key={index}>
                          <td>
                            <span
                              className={`badge ${
                                item.ERRO === "Natureza não existe para o CC"
                                  ? "bg-danger"
                                  : item.ERRO === "Sem Orçamento"
                                  ? "bg-warning text-dark"
                                  : item.ERRO === "CC não existe para Natureza"
                                  ? "bg-info"
                                  : "bg-secondary"
                              }`}
                            >
                              {item.ERRO === "Natureza não existe para o CC"
                                ? "Natureza não existe"
                                : item.ERRO ===
                                  "Sem Natureza Orçamentrária no Movimento"
                                ? "Sem Natureza"
                                : item.ERRO}
                            </span>
                          </td>
                          <td>
                            <div>
                              <strong className="font-monospace">
                                {item.CODCCUSTO}
                              </strong>
                              <br />
                              <small className="text-muted">
                                {item.CENTROCUSTO}
                              </small>
                            </div>
                          </td>
                          <td>
                            <div>
                              <strong className="font-monospace">
                                {item.CODTBORCAMENTO || "NULL"}
                              </strong>
                              <br />
                              <small className="text-muted">
                                {item.NATUREZA || "N/A"}
                              </small>
                            </div>
                          </td>
                          <td>
                            <span className="badge bg-primary fs-6">
                              {item.QUANTIDADE}
                            </span>
                            <small className="text-muted d-block">
                              registros
                            </small>
                          </td>
                          <td>
                            <button
                              className="btn btn-sm btn-warning me-1"
                              onClick={() => abrirModal(item)}
                              title="Corrigir em Lote"
                            >
                              <i className="bi bi-tools me-1"></i>
                              Corrigir Lançamentos
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>

            {/* Paginação */}
            <div className="card-footer bg-light">
              <div className="d-flex justify-content-between align-items-center">
                <div className="text-muted">
                  Mostrando {(paginaAtual - 1) * registrosPorPagina + 1} até{" "}
                  {Math.min(
                    paginaAtual * registrosPorPagina,
                    dadosParaPaginacao.length
                  )}{" "}
                  de {dadosParaPaginacao.length} registros
                </div>
                <nav>
                  <ul className="pagination pagination-sm mb-0">
                    <li
                      className={`page-item ${
                        paginaAtual === 1 ? "disabled" : ""
                      }`}
                    >
                      <button className="page-link" onClick={paginaAnterior}>
                        <i className="bi bi-chevron-left"></i>
                      </button>
                    </li>

                    {[...Array(totalPaginas)].map((_, i) => {
                      const pagina = i + 1;
                      if (
                        pagina === 1 ||
                        pagina === totalPaginas ||
                        (pagina >= paginaAtual - 2 && pagina <= paginaAtual + 2)
                      ) {
                        return (
                          <li
                            key={pagina}
                            className={`page-item ${
                              paginaAtual === pagina ? "active" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => irParaPagina(pagina)}
                            >
                              {pagina}
                            </button>
                          </li>
                        );
                      } else if (
                        pagina === paginaAtual - 3 ||
                        pagina === paginaAtual + 3
                      ) {
                        return (
                          <li key={pagina} className="page-item disabled">
                            <span className="page-link">...</span>
                          </li>
                        );
                      }
                      return null;
                    })}

                    <li
                      className={`page-item ${
                        paginaAtual === totalPaginas ? "disabled" : ""
                      }`}
                    >
                      <button className="page-link" onClick={proximaPagina}>
                        <i className="bi bi-chevron-right"></i>
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal de Ajuste */}
      {showModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-warning text-dark">
                <h5 className="modal-title">
                  <i className="bi bi-tools me-2"></i>
                  {abaAtiva === "detalhado"
                    ? "Ajustar Não Conformidade"
                    : "Correção em Lote"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={fecharModal}
                ></button>
              </div>
              <div className="modal-body">
                {registroSelecionado && (
                  <>
                    {/* Informações do Registro */}
                    <div className="card mb-4">
                      <div className="card-header bg-light">
                        <h6 className="mb-0">
                          <i className="bi bi-info-circle me-2"></i>
                          {abaAtiva === "detalhado"
                            ? "Informações da Solicitação"
                            : "Informações do Agrupamento"}
                        </h6>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-6">
                            <p>
                              <strong>Erro:</strong>{" "}
                              <span className="badge bg-danger">
                                {registroSelecionado.ERRO}
                              </span>
                            </p>
                            {abaAtiva === "detalhado" ? (
                              <>
                                <p>
                                  <strong>Origem:</strong>
                                  <span
                                    className={`badge ms-2 ${
                                      registroSelecionado.ORIGEM === "1.1.37"
                                        ? "bg-success"
                                        : registroSelecionado.ORIGEM === "FIN"
                                        ? "bg-warning text-dark"
                                        : registroSelecionado.ORIGEM === "FXCX"
                                        ? "bg-info"
                                        : "bg-secondary"
                                    }`}
                                  >
                                    {registroSelecionado.ORIGEM === "1.1.37"
                                      ? "Compras (1.1.37)"
                                      : registroSelecionado.ORIGEM === "FIN"
                                      ? "Financeiro (FIN)"
                                      : registroSelecionado.ORIGEM === "FXCX"
                                      ? "Extrato Caixa (FXCX)"
                                      : registroSelecionado.ORIGEM}
                                  </span>
                                </p>
                                <p>
                                  <strong>Responsável:</strong>{" "}
                                  {registroSelecionado.CODRESPLAN}
                                </p>
                              </>
                            ) : (
                              <>
                                <p>
                                  <strong>Centro de Custo:</strong>{" "}
                                  {registroSelecionado.CODCCUSTO}
                                </p>
                                <p>
                                  <strong>Quantidade:</strong>{" "}
                                  <span className="badge bg-primary">
                                    {registroSelecionado.QUANTIDADE} registros
                                  </span>
                                </p>
                              </>
                            )}
                          </div>
                          <div className="col-md-6">
                            {abaAtiva === "detalhado" ? (
                              <>
                                <p>
                                  <strong>Fornecedor:</strong>{" "}
                                  {registroSelecionado.FORNECEDOR || "N/A"}
                                </p>
                                <p>
                                  <strong>Valor:</strong>{" "}
                                  {parseFloat(
                                    registroSelecionado.LIQUIDO || 0
                                  ).toLocaleString("pt-BR", {
                                    style: "currency",
                                    currency: "BRL",
                                  })}
                                </p>
                                <p>
                                  <strong>Data:</strong>{" "}
                                  {registroSelecionado.DTORIG
                                    ? new Date(
                                        registroSelecionado.DTORIG
                                      ).toLocaleDateString("pt-BR")
                                    : "N/A"}
                                </p>
                              </>
                            ) : (
                              <>
                                <p>
                                  <strong>Descrição CC:</strong>{" "}
                                  <small>
                                    {registroSelecionado.CENTROCUSTO}
                                  </small>
                                </p>
                                <p>
                                  <strong>Natureza:</strong>{" "}
                                  {registroSelecionado.CODTBORCAMENTO || "NULL"}
                                </p>
                                <p>
                                  <strong>Descrição Natureza:</strong>{" "}
                                  <small>
                                    {registroSelecionado.NATUREZA || "N/A"}
                                  </small>
                                </p>
                              </>
                            )}
                          </div>
                        </div>

                        {/* ✅ ÁREA DE PRÓXIMAS AÇÕES BASEADA NO TIPO DE ERRO */}
                        {abaAtiva === "manutencao" && (
                          <div className="mt-3">
                            <div className="alert alert-success">
                              <h6 className="alert-heading">
                                <i className="bi bi-lightbulb me-2"></i>
                                Próxima Ação Após Correção:
                              </h6>
                              <p className="mb-0">
                                {(() => {
                                  switch (registroSelecionado.ERRO) {
                                    case "CC não existe para Natureza":
                                    case "Sem Orçamento":
                                      return "📋 Solicitar para Solange dar manutenção para colocar gestor para esse centro de custo.";

                                    case "Natureza não existe para o CC":
                                      return "✅ A natureza já estará disponível para consulta no sistema.";

                                    case "Sem Centro de Custo no Movimento":
                                    case "Sem Natureza Orçamentrária no Movimento":
                                      return "🛒 Verificar com time de compras porque não foi colocado o centro de custo ou natureza no movimento.";

                                    default:
                                      return "✅ Aguardar processamento do sistema.";
                                  }
                                })()}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Formulário de Ajuste */}
                    <div className="row">
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="form-label fw-bold">
                            Centro de Custo
                          </label>
                          <input
                            type="text"
                            className="form-control bg-light font-monospace"
                            value={registroSelecionado.CODCCUSTO || "N/A"}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="form-label fw-bold">Natureza</label>
                          <input
                            type="text"
                            className="form-control bg-light font-monospace"
                            value={registroSelecionado.CODTBORCAMENTO || "NULL"}
                            disabled
                          />
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="form-label fw-bold">
                            <span className="text-danger">*</span> Classificação
                          </label>
                          <select
                            className="form-select font-monospace"
                            name="classificacao"
                            value={formData.classificacao}
                            onChange={handleInputChange}
                            required
                          >
                            <option value="">Selecione...</option>
                            <option value="1">1 - Despesas</option>
                            <option value="2">2 - Investimento</option>
                            <option value="3">3 - Rec.Diversas</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="mb-3">
                      <label className="form-label fw-bold">Observações</label>
                      <textarea
                        className="form-control"
                        rows="3"
                        name="observacao"
                        value={formData.observacao}
                        onChange={handleInputChange}
                        placeholder="Descreva o motivo do ajuste e outras informações relevantes..."
                      ></textarea>
                    </div>
                  </>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={fecharModal}
                >
                  <i className="bi bi-x-circle me-2"></i>
                  Cancelar
                </button>
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={salvarAjuste}
                  disabled={!formData.classificacao}
                >
                  <i className="bi bi-check-circle me-2"></i>
                  {abaAtiva === "detalhado"
                    ? "Salvar Ajuste"
                    : "Aplicar Correção em Lote"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      </div>
    </div>
  );
};

export default AnaliseNaoConformidades;
